// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"FW-z","inlineTitle":"GW-z","sponsoredAdsWrapper":"HW-z","marketplaceRecosWrapper":"IW-z"};